<template>
	<CLoader :pConfigLoad="ConfigLoad">
        <template slot="BodyFormLoad">
			<div class="container-fluid">
				<form id="FormCpvehiculo" role="form" method="post" autocomplete="off" onSubmit="return false">	
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
							<label class="form-label" for="IdChofer">Chofer</label>
							<select v-model="objCpVehiculo.IdChofer" class="form-control-search form-select" id="IdChofer">
								<option value="">Seleccione una opción</option>
								<option v-for="(item, index) in Choferes" :key="index" :value="item.IdChofer">{{item.Nombre + ' ' + item.ApellidoPat + ' ' + item.ApellidoMat}}</option>
							</select>
							<CValidation v-if="this.errorvalidacion.IdChofer" :Mensaje="'*'+errorvalidacion.IdChofer[0]"/>
						</div>

						<div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
							<label class="form-label" for="Marca">Marca</label>
							<input type="text" v-model="objCpVehiculo.Marca" class="form-control" id="Marca" placeholder="Ingresar Marca" />
							<CValidation v-if="this.errorvalidacion.Marca" :Mensaje="'*'+errorvalidacion.Marca[0]"/>
						</div>

						<div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
							<label class="form-label" for="Modelo">Modelo</label>
							<input type="text" v-model="objCpVehiculo.Modelo" class="form-control" id="Modelo" placeholder="Ingresar Modelo" />
							<CValidation v-if="this.errorvalidacion.Modelo" :Mensaje="'*'+errorvalidacion.Modelo[0]"/>
						</div>
					</div>
					
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
							<label class="form-label" for="Serie">Serie</label>
							<input type="text" v-model="objCpVehiculo.Serie" class="form-control" id="Serie" placeholder="Ingresar Serie" />
							<CValidation v-if="this.errorvalidacion.Serie" :Mensaje="'*'+errorvalidacion.Serie[0]"/>
						</div>

						<div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
							<label class="form-label" for="Placa">Placa</label>
							<input type="text" v-model="objCpVehiculo.Placa" class="form-control" id="Placa" placeholder="Ingresar Placa" />
							<CValidation v-if="this.errorvalidacion.Placa" :Mensaje="'*'+errorvalidacion.Placa[0]"/>
						</div>

						<div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
							<label class="form-label" for="NoEconomico">N° Economico</label>
							<input type="text" v-model="objCpVehiculo.NoEconomico" class="form-control" id="NoEconomico" placeholder="Ingresar N° Economico" />
							<CValidation v-if="this.errorvalidacion.NoEconomico" :Mensaje="'*'+errorvalidacion.NoEconomico[0]"/>
						</div>

						<div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
							<label class="form-label" for="Aseguradora">Aseguradora</label>
							<input type="text" v-model="objCpVehiculo.Aseguradora" class="form-control" id="Aseguradora" placeholder="Ingresar Aseguradora" />
							<CValidation v-if="this.errorvalidacion.Aseguradora" :Mensaje="'*'+errorvalidacion.Aseguradora[0]"/>
						</div>
					</div>
					
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
							<label class="form-label" for="Poliza">Poliza</label>
							<input type="text" v-model="objCpVehiculo.Poliza" class="form-control" id="Poliza" placeholder="Ingresar Poliza" />
							<CValidation v-if="this.errorvalidacion.Poliza" :Mensaje="'*'+errorvalidacion.Poliza[0]"/>
						</div>

						<div class="col-12 col-sm-12 col-md-8 col-lg-8 col-xl-8">
							<label class="form-label" for="PermisoSCT">Permiso SCT</label>
							<select v-model="objCpVehiculo.PermisoSCT" class="form-control-search form-select" id="PermisoSCT">
								<option value="">Seleccione una opción</option>
								<option v-for="(item, index) in PermisosSCT" :key="index" :value="item.Clave">{{item.Clave+' - '+item.Descripcion}}</option>
							</select>
							<CValidation v-if="this.errorvalidacion.PermisoSCT" :Mensaje="'*'+errorvalidacion.PermisoSCT[0]"/>
						</div>
					</div>
					
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
							<label class="form-label" for="NumPermisoSCT">Número PermisoSCT</label>
							<input type="text" v-model="objCpVehiculo.NumPermisoSCT" class="form-control" id="NumPermisoSCT" placeholder="Ingresar Número PermisoSCT" />
							<CValidation v-if="this.errorvalidacion.NumPermisoSCT" :Mensaje="'*'+errorvalidacion.NumPermisoSCT[0]"/>
						</div>

						<div class="col-12 col-sm-12 col-md-8 col-lg-8 col-xl-8">
							<label class="form-label" for="ConfigVehicular">Configuración Vehicular</label>
							<select v-model="objCpVehiculo.ConfigVehicular" class="form-control-search form-select" id="ConfigVehicular">
								<option value="">Seleccione una opción</option>
								<option v-for="(item, index) in ConfiguracionesVehiculares" :key="index" :value="item.Clave">{{item.Clave +' - '+item.Nombre}}</option>
							</select>
							<CValidation v-if="this.errorvalidacion.ConfigVehicular" :Mensaje="'*'+errorvalidacion.ConfigVehicular[0]"/>
						</div>
					</div>
											
					<br>
				
				</form>
			</div>
		</template>
	</CLoader>
</template>

<script>

export default {
    name: 'FormCpvehiculo',
    props: ['poBtnSave'],
    components:{
    },
    data() {
        return {
			ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
            objCpVehiculo: {
				IdVehiculo: 0,
				IdChofer: 0,
				Marca: '',
				Modelo: '',
				Serie: '',
				Placa: '',
				NoEconomico: '',
				Aseguradora: '',
				Poliza: '',
				PermisoSCT: '',
				NumPermisoSCT: '',
				ConfigVehicular: '',
            },
            errorvalidacion: [],
			Emit: this.poBtnSave.EmitSeccion,
			//masks:{ input: 'YYYY-MM-DD'}, // quitar sino lleva fecha
			Choferes: [],
			PermisosSCT: [],
			ConfiguracionesVehiculares: [],
        }
    },
    methods :
    {
       	async Guardar()
        {
			this.errorvalidacion = [];
            this.poBtnSave.Toast = 0; 
            this.poBtnSave.DisableBtn = true;

			if(this.objCpVehiculo.IdVehiculo == 0) {
				await this.$http.post(
					'cpVehiculos',this.objCpVehiculo
				).then((res)=>{
					this.EjecutaConExito(res);
				}).catch(err=>{   
					this.EjecutaConError(err);
				});
			} else {
				await this.$http.put(
					'cpVehiculos/'+this.objCpVehiculo.IdVehiculo,
					this.objCpVehiculo
				).then((res)=>{                 
					this.EjecutaConExito(res);
				}).catch(err=>{   
					this.EjecutaConError(err);
				});
			}
        },
		EjecutaConExito(res)
        {
            this.poBtnSave.DisableBtn = false;  
            this.poBtnSave.Toast = 1;
            this.bus.$emit('CloseModal_'+this.Emit);
            this.bus.$emit('List_'+this.Emit);
        },
        EjecutaConError(err)
        {
            this.poBtnSave.DisableBtn = false;
            
            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.poBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }
        },
		Recuperar()
        {
            this.$http.get(
                "cpVehiculos/"+this.objCpVehiculo.IdVehiculo
            ).then((res) => {
                this.objCpVehiculo = res.data.data;

				// en caso de que necesite fecha
				/*let formatedDate1 = this.objCpVehiculo.Fecha.replace(/-/g,'\/');
                this.objCpVehiculo.Fecha = new Date(formatedDate1);*/
            }).finally(()=>{
                this.ConfigLoad.ShowLoader = false;
            });
        },
        Limpiar()
        {
            this.objCpVehiculo = {
				IdVehiculo: 0,
				IdChofer: '',
				Marca: '',
				Modelo: '',
				Serie: '',
				Placa: '',
				NoEconomico: '',
				Aseguradora: '',
				Poliza: '',
				PermisoSCT: '',
				NumPermisoSCT: '',
				ConfigVehicular: '',
            }
            this.errorvalidacion = [];
        },
		GetChoferes()
		{
			this.$http.get("cpChoferes", {
				params:{
					simple: 1,
				}
			}).then((res) => {
				this.Choferes = res.data.data;
			});
		},
		GetPermisosSCT()
		{
			this.$http.get("cpPermisosSct", {
				params:{
					simple: 1,
				}
			}).then((res) => {
				this.PermisosSCT = res.data.data;
			});
		},
		GetConfiguracionesVehiculares()
		{
			this.$http.get("cpConfigAutoTransportes", {
				params:{
					simple: 1,
				}
			}).then((res) => {
				this.ConfiguracionesVehiculares = res.data.data;
			});
		},
    },
    created() {
		this.poBtnSave.Toast = 0;

        this.bus.$off('Recovery_'+this.Emit);
        this.bus.$on('Recovery_'+this.Emit,(Id)=>
        {
            this.ConfigLoad.ShowLoader = true;    
            this.poBtnSave.DisableBtn = false;
			this.GetChoferes();
			this.GetPermisosSCT();
			this.GetConfiguracionesVehiculares();

            this.bus.$off('Save_'+this.Emit);
            this.bus.$on('Save_'+this.Emit,()=>
            {
                this.Guardar();
            });
            this.Limpiar();
                
            if (Id!='') 
            {
                this.objCpVehiculo.IdVehiculo = Id;
                this.Recuperar();
            }
            else
            {
                this.ConfigLoad.ShowLoader = false;
            }
        });
    }
}
</script>
